import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useEffect, useState } from 'react';
export const StoreContext = createContext(null);
export const StoreContextProvider = ({ children }) => {
    const [filteredItems, setFilteredItems] = useState({
        hide: [],
        show: [],
    });
    useEffect(() => {
        if (!filteredItems.hide.length && !filteredItems.show.length)
            return;
        filteredItems.hide.forEach((card) => {
            card.setAttribute('hidden', '');
        });
        filteredItems.show.forEach((card) => {
            card.removeAttribute('hidden');
        });
    }, [filteredItems]);
    return (_jsx(StoreContext.Provider, { value: {
            filteredItems,
            setFilteredItems,
        }, children: children }));
};
